import { render } from "./BImage.vue?vue&type=template&id=5be0e896"
import script from "./BImage.vue?vue&type=script&lang=js"
export * from "./BImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__